import React, { useCallback } from 'react';
import { BiChevronUp } from 'react-icons/bi';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';

import { toggleNavigation } from '../../redux/actions';

const useStyles = createUseStyles({
  button: {
    '&:hover': { background: '#1C1C1C', color: '#FFFFFF' },
    background: '#202124',
    color: '#393939',
    composes: ['pt6', 'pb6', 'is-full-width'],
    transition: 'background 0.3s, color 0.3s',
  },
});

const CloseButtonComponent = React.memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const closeHandler = useCallback(() => {
    dispatch(toggleNavigation(null));
  }, [dispatch]);

  return (
    <button className={classes.button} type="button" onClick={closeHandler}>
      <BiChevronUp size="24" />
    </button>
  );
});

CloseButtonComponent.displayName = 'CloseButtonComponent';

export default CloseButtonComponent;
